import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';

@Injectable()
export class HttpTrafficInterceptor implements HttpInterceptor {

  constructor(private router: Router, private common: CommonService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.common.setComm(true);
    return next.handle(request)
      .pipe(
      map(r => {        
          this.common.setComm(false);
          return r;
        }),
        catchError(e => {
          this.common.setComm(false);
          return throwError(e);
        })
      );
  }

}